import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import messages from 'components/MyContractInfo/ASIContractInfo/messages';
import {
  StyledCaption,
  StyledPaper,
  StyledShortBody,
} from 'components/MyContractInfo/styles';
import { get } from 'lodash';
import React, { ReactNode } from 'react';
import { injectIntl, IntlShape, useIntl } from 'react-intl';

interface ContractItemProps {
  label: string;
  value: string | ReactNode;
}
const ContractItem = ({ value, label }: ContractItemProps) => {
  const { formatMessage } = useIntl();

  return (
    <Grid item sm={6} md={4}>
      <Grid container direction="column">
        <Grid item>
          <StyledCaption>{formatMessage(get(messages, label))}</StyledCaption>
        </Grid>
        <Grid item>
          <Box marginBottom={2}>
            {typeof value === 'string' ? (
              <StyledShortBody>{value}</StyledShortBody>
            ) : (
              value
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface ASIContractInfoType {
  intl: IntlShape;
  plafond: number;
  franchise: number;
  effectiveDate: string;
  dueDate: string;
}
const ASIContractInfo = (props: ASIContractInfoType) => {
  const { plafond, franchise, effectiveDate, dueDate } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const parentDirection = matches ? 'row' : 'column';
  const childDirection = matches ? 'column' : 'row';

  return (
    <StyledPaper>
      <Box padding={2}>
        <Grid container justify="space-between" direction={parentDirection}>
          <Grid item xs={6} sm={12}>
            <Grid container direction={childDirection}>
              <ContractItem label="plafond" value={plafond} />
              <ContractItem label="franchise" value={franchise} />
              <ContractItem label="effectiveDate" value={effectiveDate} />
            </Grid>
          </Grid>
          <Grid item xs={6} sm={12}>
            <Grid container direction={childDirection}>
              <ContractItem label="dueDate" value={dueDate} />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </StyledPaper>
  );
};

export default injectIntl(ASIContractInfo);
